export default function tabsComponent({main, on, elm}) {
    const tabs = [...elm.querySelectorAll('[role="tab"]')];
    const panels = [...elm.querySelectorAll('[role="tabpanel"]')];

    main(() => {
        on('click', '[role="tab"]', switchTab);
    });

    const switchTab = function(e) {
        const selectedTab = e.target.closest('[role="tab"]');
        if (!selectedTab) return;

        tabs.forEach(t => {
            const selected = t === selectedTab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.tabIndex = selected ? 0 : -1;
        });

        panels.forEach(panel => {
            panel.hidden = panel.getAttribute('aria-labelledby') !== selectedTab.id;
        });
    };
};

export const model = {};
